import type { AccommodationQuantities } from "@@/shared/acquire/accommodation-quantity";
import type { ResourceAccommodation } from "@@/shared/acquire/resources/resource-accommodation/resource-accommodation";
import { getPossibilities } from "@@/shared/acquire/sessions/verify-requested-quantities-are-possible-to-distribute-among-resources";

const isResourcesAccommodationsWithinCapacity = (
    resources: ResourceAccommodation[],
    requestedResourceQuantity: number,
    quantities: AccommodationQuantities,
) => {
    const possibilities = getPossibilities({
        availableResources: resources,
        numberOfResources: requestedResourceQuantity,
        requestedQuantities: quantities,
    });

    return possibilities.firstPossibleCombination.map(resource => {
        return { resource, error: false };
    });

    // const result = resources.map(resource => {
    //     const res = isResourceAccommodationWithinCapacity(
    //         resource,
    //         requestedResourceQuantity,
    //         quantities,
    //     );

    //     if (res === true) {
    //         return { resource, error: false };
    //     }
    //     return { resource, error: true, errorMessage: res.errorMessage };
    // });

    // return result;
};

// const isResourceAccommodationWithinCapacity = (
//     resource: ResourceAccommodation,
//     requestedResourceQuantity: number,
//     quantities: AccommodationQuantities,
// ): { type: AccommodationQuantityType; errorMessage: Translatable } | true => {
//     if (isResourceAccommodation(resource)) {
//         try {
//             verifyRequestedQuantitiesArePossibleToDistributeAmongResources({
//                 resources: repeat(
//                     resource.capacity,
//                     requestedResourceQuantity,
//                 ).map(capacity => ({
//                     capacity,
//                     resourceId: resource._id,
//                 })),
//                 requestedQuantity: quantities,
//             });
//         } catch (error) {}
//     }

//     // const avgQuantities = getAverageQuantities(
//     //     quantities,
//     //     requestedResourceQuantity,
//     // );
//     // const getQuantity = (key: AccommodationQuantityType) =>
//     //     avgQuantities.get(key) ?? 0;

//     if (isResourceAccommodation(resource)) {
//         const guestCapacity = resource.capacity.GUEST;

//         const amountOfSleepingSpots =
//             getQuantity("ADULT") + getQuantity("CHILD") + getQuantity("GUEST");

//         const min = guestCapacity?.min ?? 0;
//         const max = guestCapacity?.max ?? Number.MAX_SAFE_INTEGER;
//         //Check if the amount of sleeping spots is within the capacity
//         // eslint-disable-next-line no-console
//         console.log("Q_GUEST", { amountOfSleepingSpots, min, max });
//         if (amountOfSleepingSpots < min || amountOfSleepingSpots > max) {
//             const meta = accommodationQuantityTypeMeta["GUEST"];

//             return {
//                 type: "GUEST",
//                 errorMessage: translatedFactory({
//                     sv: `Antalet ${meta.name.plural.sv} måste vara mellan ${min} och ${max}`,
//                     en: `The number of ${meta.name.plural.en} must be between ${min} and ${max}`,
//                 }),
//             };
//         }
//         //Check if the amount of other types of guests are within the capacity
//         for (const key of [
//             "ADULT",
//             "CHILD",
//             "INFANT",
//             "ANIMAL",
//         ] as AccommodationQuantityType[]) {
//             const capacity = resource.capacity[key];
//             const min = capacity?.min ?? 0;
//             const max = capacity?.max ?? 999999;

//             const q = getQuantity(key);
//             // eslint-disable-next-line no-console
//             console.log("Q_" + key, { q, min, max });
//             if (q < min || q > max) {
//                 const meta = accommodationQuantityTypeMeta[key];

//                 return {
//                     type: key,
//                     errorMessage: translatedFactory({
//                         sv: `Antalet ${meta.name.plural.sv} måste vara mellan ${min} och ${max}`,
//                         en: `The number of ${meta.name.plural.en} must be between ${min} and ${max}`,
//                     }),
//                 };
//             }
//         }
//     } else if (!isResourceGroup(resource)) {
//         const sum =
//             getQuantity("ADULT") +
//             getQuantity("CHILD") +
//             getQuantity("INFANT") +
//             getQuantity("GUEST");

//         if (resource.quantity === "INFINITE") return true;

//         if (resource.quantity < sum) {
//             return {
//                 type: "GUEST",
//                 errorMessage: translatedFactory({
//                     sv: `Antalet gäster måste vara mindre än ${resource.quantity}`,
//                     en: `The number must be less than ${resource.quantity}`,
//                 }),
//             };
//         }

//         return true;
//     }

//     return true;
// };
export {
    // isResourceAccommodationWithinCapacity,
    isResourcesAccommodationsWithinCapacity,
};
